module.exports = __webpack_public_path__ + "8b1680290ae798fedfeee24b8a3ebfe4.jpg";